export function copy_to_clipboard(texto: string) {
    if (!texto && texto !== 'undefined' ) return;
    // Crear un elemento temporal para copiar el texto
    var elementoTemporal = document.createElement("textarea");
    elementoTemporal.value = texto;
    elementoTemporal.setAttribute("readonly", "");
    elementoTemporal.style.position = "absolute";
    elementoTemporal.style.left = "-9999px"; // Mover el elemento fuera del área visible
    document.body.appendChild(elementoTemporal);

    // Seleccionar y copiar el contenido del elemento temporal
    elementoTemporal.select();
    document.execCommand("copy");

    // Eliminar el elemento temporal
    document.body.removeChild(elementoTemporal);
}